export default __webpack_public_path__ + "static/media/eb-wht-1.c7b244df.png";